<!-- A navigation bar tabs with two slots to be able to add a meta bar with additionnal data -->
<template>
  <div :class="'nav-'+theme" class="nav-tabs-extended mb-3">
    <nav class="nav nav-meta nav-tabs">
      <div class="nav-container">
        <div class="nav-item d-flex">
          <slot name="meta-bar-left" />
        </div>

        <!-- used to pull the fleet to the right -->
        <div class="d-none d-lg-block" style="flex: 1;" />

        <div class="nav-item d-flex">
          <slot name="meta-bar-right" />
        </div>
      </div>
    </nav>

    <nav class="nav nav-tabs">
      <div class="nav-container">
        <slot name="tabs-bar" />
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'light'
    }
  }
}
</script>

<style lang="scss">
  @import "~@/scss/variables";

  .nav-tabs-extended {
    .nav {
      margin-top: -20px;
      margin-right: -20px;
      margin-left: -20px;
      border-bottom: none;

      & + .nav {
        margin-top: 0;
      }

      @media (min-width: $grid-breakpoint-xl) {
        position: relative;
        right: 50%;
        left: 50%;
        width: calc(100vw - #{$sidebar-width});
        margin-top: -20px;
        margin-right: calc(-50vw + #{$sidebar-width} / 2);
        margin-left: calc(-50vw + #{$sidebar-width} / 2);
      }

      .nav-container {
        display: flex;
        padding-right: 20px;
        padding-left: 20px;
        overflow-x: auto;
        overflow-y: hidden;

        @media (min-width: $grid-breakpoint-md) {
          width: 80vw;
        }

        @media (min-width: $grid-breakpoint-xl) {
          margin-right: auto;
          margin-left: auto;
        }

        .nav-item {
          margin-bottom: 0;
        }
      }

      &.nav-meta .nav-container .nav-item {
        padding: 0.8rem 0;

        span {
          font-size: 0.75rem;
        }
      }

      .dropdown {
        .icon-angle-right {
          display: inline-block;
          font-size: 1.1rem;
          transition: transform 0.35s ease;
        }

        &.show {
          .icon-angle-right {
            transform: rotate(-90deg);
          }
        }

        &:not(.show) {
          .icon-angle-right {
            transform: rotate(90deg);
          }
        }
      }
    }

    &.nav-dark {
      .nav.nav-meta {
        color: $white;
        background-color: lighten($primary, 2%);
      }

      .nav.nav-meta + .nav {
        background-color: lighten($primary, 8%);

        &.nav-tabs .nav-item .nav-link {
          color: $white;
          background-color: transparent;

          &.active {
            box-shadow: inset 0 -3px 0 $secondary;
          }
        }

        i.icon-more,
        i.icon-angle-right {
          color: $white;
        }
      }
    }

    &.nav-light {
      .nav.nav-meta {
        color: $white;
        background-color: lighten($primary, 8%);
      }
    }
  }
</style>
